"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = _interopRequireDefault(require("./amb.ChannelListener"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChannelRedirect = function ChannelRedirect(
/*cometd*/
cometd,
/*amb.ServerConnection*/
serverConnection) {
  var _metaChannel;

  var _cometd = cometd;
  var LOGGER = new _amb.default('amb.ChannelRedirect');

  function _switchToChannel(fromChannel, toChannel) {
    var listeners = fromChannel.getChannelListeners();

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener.setNewChannel(toChannel);
    }
  }

  function _onAdvice(advice) {
    LOGGER.debug('_onAdvice:' + advice.data.clientId);
    var channels = serverConnection.getChannels();
    var fromChannel = channels != null ? channels[advice.data.fromChannel] : null;

    if (!fromChannel) {
      var removedChannels = serverConnection.getRemovedChannels();
      fromChannel = removedChannels != null ? removedChannels[advice.data.fromChannel] : null;
    }

    var toChannel = serverConnection.getChannel(advice.data.toChannel);

    if (!fromChannel || !toChannel) {
      LOGGER.debug('Could not redirect from ' + advice.data.fromChannel + ' to ' + advice.data.toChannel);
      return;
    }

    _switchToChannel(fromChannel, toChannel);

    LOGGER.debug('published channel switch event, fromChannel:' + fromChannel.getName() + ', toChannel:' + toChannel.getName());
  }

  return {
    initialize: function initialize(
    /*Function*/
    onSubscriptionCompleted) {
      var channelName = '/sn/meta/channel_redirect/' + _cometd.getClientId();

      var newMetaChannel = serverConnection.getChannel(channelName); // Only do this when we're creating a new redirect channel

      if (!_metaChannel || newMetaChannel !== _metaChannel) {
        // Delete old redirect channel in case of reconnection
        if (_metaChannel) serverConnection.removeChannel(_metaChannel.getName());
        _metaChannel = newMetaChannel; //channelRedirect meta channelListener will not get redirected

        new _amb2.default(_metaChannel, serverConnection, onSubscriptionCompleted).subscribe(_onAdvice);
      } else _metaChannel.subscribeToCometD();

      LOGGER.debug("ChannelRedirect initialized: " + channelName);
    },
    _onAdvice: _onAdvice
  };
};

var _default = ChannelRedirect;
exports.default = _default;